import React from "react"

import { AiOutlineShareAlt } from "../../../../AppReactIcons"
import makeDate from "../../../../utils/makeDate"
import { iPageContext } from "../../../types"
import { ContentSeparator } from "../../Utils/ContentSeparator"
import Breadcrumbs from "../Breadcrumbs"
import { BreadcrumbType } from "../types"
import getBookmarkIcon from "../utils/getBookmarkIcon"
import Info from "./Info"
import RelatedVideos from "./RelatedVideos"
import UsefulLinks from "./UsefulLinks"

interface iArticlePageSidePanel {
  pageContext: iPageContext
  onClickBookmark: () => void
  onClickDiscussion: () => void
  onClickShare: () => void
  bookmarked: boolean | null
  breadcrumbs?: BreadcrumbType[]
}

const PanelButton: React.FC<{
  text?: string
  Icon?: any
  onClick: () => void
}> = ({ text, Icon, onClick }) => {
  return (
    <button className="flex items-center leading-none" onClick={onClick}>
      {Icon && <span className="mr-2 text-lg">{Icon}</span>}
      {text && <span className="text-sm">{text}</span>}
    </button>
  )
}

const ArticlePageSidePanel: React.FC<iArticlePageSidePanel> = ({
  pageContext,
  onClickBookmark,
  onClickShare,
  bookmarked,
  breadcrumbs,
  onClickDiscussion,
}) => {
  return (
    <div className="py-8 px-8 h-full relative">
      <div className="text-site-blue-dark">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Info
          title="Last updated on"
          text={makeDate(pageContext.data.last_updated_at)}
        />
        <Info title="Read time" text={pageContext.data.read_time} />
        {[1, 2, 3, 4, 5, 6].map(index => (
          <ContentSeparator key={index} />
        ))}
        {/*
          <PanelButton
          onClick={onClickDiscussion}
          text="Discussion forum"
          Icon={<FaRegComment />}
        />
           */}
        <ContentSeparator />
        <PanelButton
          onClick={onClickBookmark}
          text={bookmarked ? "Unmark" : "Bookmark"}
          Icon={getBookmarkIcon(bookmarked)}
        />
        <ContentSeparator />
        <PanelButton
          onClick={onClickShare}
          text={"Share"}
          Icon={
            <span className="text-xl">
              <AiOutlineShareAlt />
            </span>
          }
        />
        <ContentSeparator />
        <div className="bg-gray-300 w-full" style={{ height: "1px" }} />
        <ContentSeparator />
        <RelatedVideos links={pageContext.data.related_videos} />
        <ContentSeparator />
        <UsefulLinks links={pageContext.data.useful_links} />
      </div>
    </div>
  )
}

export default ArticlePageSidePanel
